import { useJackpotNotifier } from '@features/WinningToasts/lib';

export const ToastController = () => {
  useJackpotNotifier();
  return null;
};
